import { months, pad, statusOptions, VueDate } from '../../views/utils'

export default {
  auto: '*',
  store: {
    state: {
      currencies: [
        {
          code: 'EUR',
          name: 'Euro',
          symbol: '€',
        },
        {
          code: 'USD',
          name: 'US Dollar',
          symbol: '$',
        },
        {
          code: 'GBP',
          name: 'British Pound',
          symbol: '£',
        },
        // {
        //   code: 'CAD',
        //   name: 'Canadian Dollar',
        //   symbol: '$',
        // },
        // {
        //   code: 'AUD',
        //   name: 'Australian Dollar',
        //   symbol: '$',
        // },
        // {
        //   code: 'NZD',
        //   name: 'New Zealand Dollar',
        //   symbol: '$',
        // },
      ],
    },
    getters: {
      getCurrency: state => (code = 'EUR') => state.currencies
        .find(currency => currency.code === code.toUpperCase()),

      currencies: state => state.currencies,
      currenciesOptions: state => state.currencies.map(({ code, name }) => [code, name]),

      invoiceFilename: (_, { hasPermissions, query }) =>
        ({ invoiceAt, invoiceNo, jobcardId }, { invoiceNo: nextInvoiceNo } = {}) => {
          if (!hasPermissions('jobcards.read')) return invoiceNo

          const { vehicleId } = query('jobcards', jobcardId, true)
          const { brand, plate } = query('vehicles', vehicleId, true)

          if (!event) return `${brand | ''} ${plate || ''}`

          const date = pad(invoiceAt.getDate())
          const month = invoiceAt.getMonth()
          const monthName = months[month]

          const addedInvoiceNo = invoiceNo || nextInvoiceNo

          return `${monthName}-${date} ${brand || 'NA'} ${plate || 'NA'} (${addedInvoiceNo || 'NA'})`
        },

      genInvoiceOptions: (_, { overrideWithGroupSettings }) => () => {
        return overrideWithGroupSettings({
          invoiceAt: VueDate(),
          invoiceFormat: 'pdf',
          // invoiceAddress: null,
          // invoiceEmail: null,
          // invoiceName: null,
          // invoicePhone: null,
          isEstimated: false,
          isOnlyDone: true,
          isVatEnabled: true,
          isVatIncluded: false,
          invoiceNo: null,
        })
      },

      invoicesStatuses: () => ({
        null: { name: 'No status', theme: 'neutral' },
        1: { name: 'Agreed', theme: 'info' },
        2: { name: 'Sent', theme: 'info' },
        3: { name: 'Paid', theme: 'success' },
      }),
      invoicesStatusOptions: statusOptions('invoicesStatuses', { nullAs: false }),
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js